import React from 'react';

/**
 * What a form exposes once it is live, in plain words, one sentence a line
 * (utils/publicForms formExposure; keepr-api KPR-360). Read before a
 * package's prepared form is made live — an invite link created from it, or a
 * public form given its address.
 */
export default function FormExposure({ lines = [], className = '' }) {
	if (!lines.length) return null;
	return (
		<ul className={`form-exposure ${className}`.trim()} data-testid="form-exposure">
			{lines.map(line => <li key={line}>{line}</li>)}
		</ul>
	);
}
